import ImgCoffee from '../images/offers/coffee.jpg';
import ImgEvCharging1 from '../images/offers/evCharging-1.jpg';
import ImgEvCharging2 from '../images/offers/evCharging-2.jpg';
import ImgFuel98 from '../images/offers/fuel98.jpg';
import ImgFuelE851 from '../images/offers/fuelE85-1.jpg';
import ImgFuelE852 from '../images/offers/fuelE85-2.jpg';
import ImgPastries from '../images/offers/pastries.jpg';

export const OffersIllustrationsMap = {
    'illustration-coffee': ImgCoffee,
    'illustration-ev-charging-1': ImgEvCharging1,
    'illustration-ev-charging-2': ImgEvCharging2,
    'illustration-fuel-98': ImgFuel98,
    'illustration-fuel-E85-1': ImgFuelE851,
    'illustration-fuel-E85-2': ImgFuelE852,
    'illustration-pastries': ImgPastries,
};